import PropTypes from 'prop-types';

const OrderTransactionType = PropTypes.shape({
  id: PropTypes.string,
  success: PropTypes.bool,
  reference: PropTypes.string,
  message: PropTypes.string
});

export default OrderTransactionType;
